import { useState } from 'react';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      form.reset();
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9k7038h9dsfbuoi6b0g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后重试';
        if (msg.toLowerCase().includes('spam')) {
          setStatus('error');
          setErrorMsg('提交失败，请稍后重试');
        } else {
          setStatus('error');
          setErrorMsg(msg);
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络异常，请检查网络后重试');
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-2xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500">有推荐、建议或合作意向？欢迎给我们留言</p>
        </div>

        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col gap-4"
          >
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <label htmlFor="contact_name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  你的昵称
                </label>
                <input
                  id="contact_name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                  placeholder="请输入昵称"
                />
              </div>
              <div className="flex-1">
                <label htmlFor="contact_email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  电子邮箱
                </label>
                <input
                  id="contact_email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                  placeholder="请输入邮箱"
                />
              </div>
            </div>

            <div>
              <label htmlFor="contact_subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言主题
              </label>
              <input
                id="contact_subject"
                name="subject"
                type="text"
                required
                className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                placeholder="如：作品推荐 / 合作咨询"
              />
            </div>

            <div>
              <label htmlFor="contact_message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容
              </label>
              <textarea
                id="contact_message"
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors resize-none"
                placeholder="请详细描述你的建议、推荐或合作意向……"
              ></textarea>
              <p className="mt-1 text-xs text-foreground-300 text-right">最多500字</p>
            </div>

            <input name="website_alt" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />

            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {status === 'loading' ? '提交中...' : '发送留言'}
            </button>

            {status === 'success' && (
              <p className="text-center text-sm text-accent-600 font-medium">留言已成功发送，感谢你的反馈！</p>
            )}
            {status === 'error' && errorMsg && (
              <p className="text-center text-sm text-primary-600 font-medium">{errorMsg}</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}